import { render, staticRenderFns } from "./ReplyComment.vue?vue&type=template&id=b7397b12&scoped=true&"
import script from "./ReplyComment.vue?vue&type=script&lang=js&"
export * from "./ReplyComment.vue?vue&type=script&lang=js&"
import style0 from "./ReplyComment.vue?vue&type=style&index=0&id=b7397b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7397b12",
  null
  
)

export default component.exports